import { useMemo } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import ArgonButton from "components/ArgonButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

const columns1 = [
  { name: "sno", align: "center" },
  { name: "Class", align: "left" },
  { name: "Board", align: "left" },
  { name: "Medium", align: "left" },
  { name: "Year of Completion", align: "center" },
  { name: "School/University/College", align: "center" },
  { name: "Marksheet", align: "center" },
];

const EducationQualificationTableData = (tutor) => {
  const rows1 = useMemo(() => {
    if (!tutor) return [];

    const qualifications = tutor.educationQualification || [];

    return qualifications.map((edu, index) => ({
      sno: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {index + 1}
        </ArgonTypography>
      ),
      Class: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {edu?.class?.name || "N/A"}
        </ArgonTypography>
      ),
      Board: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {edu?.board?.name || "N/A"}
        </ArgonTypography>
      ),
      Medium: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {edu?.medium || "N/A"}
        </ArgonTypography>
      ),
      "Year of Completion": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {edu.completedYear || "N/A"}
        </ArgonTypography>
      ),
      "School/University/College": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {edu.schoolUniversity || "N/A"}
        </ArgonTypography>
      ),
      Marksheet: edu.marksheet ? (
        <ArgonBadge
          variant="gradient"
          badgeContent="View"
          color="success"
          size="xs"
          container
          component="a"
          href={edu.marksheet}
          target="_blank"
          rel="noopener noreferrer"
        />
      ) : (
        <ArgonTypography variant="caption" color="text">
          Not Uploaded
        </ArgonTypography>
      ),
    }));
  }, [tutor]);

  return { columns1, rows1 };
};

export default EducationQualificationTableData;

/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
// import ArgonBox from "components/ArgonBox";
// import ArgonTypography from "components/ArgonTypography";
// import ArgonAvatar from "components/ArgonAvatar";
// import ArgonBadge from "components/ArgonBadge";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import DeleteIcon from '@mui/icons-material/Delete';

// // Images
// import team2 from "assets/images/team-2.jpg";
// import team3 from "assets/images/team-3.jpg";
// import team4 from "assets/images/team-4.jpg";
// import { Button } from "@mui/material";
// import { Link } from "react-router-dom";

// function Author({ image, name, email }) {

//   return (
//     <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
//       <ArgonBox mr={2}>
//         <ArgonAvatar src={image} alt={name} size="sm" variant="rounded"/>
//       </ArgonBox>
//       <ArgonBox display="flex" flexDirection="column">
//         <ArgonTypography textTransform="none" variant="button" fontWeight="medium">
//           {name}
//         </ArgonTypography>
//         <ArgonTypography variant="caption" color="secondary">
//           {email}
//         </ArgonTypography>
//       </ArgonBox>
//     </ArgonBox>
//   );
// }

// const TeachingPreferenceTableData = {
//   columns: [

//     {name:"sno",align:"center"},
//     {name:"Class",align:"left"},
//     // {name:"Medium", align:"center"},
//     {name:"Board",align:"left"},
//     {name:"Year of Completion",align:"center"},
//     // {name:"Percentage Obtained",align:"center"},
//     {name:"School/University/college",align:"center"},
//     {name:"marksheet",align:"center"},
//   ],

//   rows: [
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{1}</ArgonTypography>,
//       "Class":<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Mathematics"}</ArgonTypography>,
//       "Medium": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"English"}</ArgonTypography>,
//       "Board": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"CBSE"}</ArgonTypography>,
//       "Year of Completion": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"Yes"}</ArgonTypography>,
//       "Percentage Obtained":<ArgonTypography variant="caption" fontWeight="medium" color="text">{"95%"}</ArgonTypography>,
//       "School/University/college":<ArgonTypography variant="caption" fontWeight="medium" color="text">{"XYZ University"}</ArgonTypography>,
//       "marksheet":(<ArgonBadge variant="gradient" badgeContent="view" color="success" size="xs" container />),

//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={0}>
//            {/* View Icon */}
//             <Button variant="text"  size="large" component={Link} to="/tutors/profile" sx={{minWidth:"12px",p:0}} >
//               <VisibilityIcon color="primary"/>
//             </Button>
//             {/* Delete icon */}
//            <Button variant="text"  size="large" sx={{minWidth:"32px",p:0}}
//            onClick={() =>handleDeleteClick()} >
//              <DeleteIcon color="error"/>
//            </Button>

//          </ArgonBox>
//        ),
//     },
//   ],
// }

// export default TeachingPreferenceTableData;
